var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataUsage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Data Usage"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M18.25 2.99609C19.7688 2.99609 21 4.22731 21 5.74609V18.2461C21 19.7649 19.7688 20.9961 18.25 20.9961H5.75C4.23122 20.9961 3 19.7649 3 18.2461V5.74609C3 4.22731 4.23122 2.99609 5.75 2.99609H18.25ZM18.25 4.49609H5.75C5.05964 4.49609 4.5 5.05574 4.5 5.74609V18.2461C4.5 18.9365 5.05964 19.4961 5.75 19.4961H18.25C18.9404 19.4961 19.5 18.9365 19.5 18.2461V5.74609C19.5 5.05574 18.9404 4.49609 18.25 4.49609ZM7.75 8.9994C8.1297 8.9994 8.44349 9.28034 8.49315 9.64485L8.5 9.74618V16.2526C8.5 16.6651 8.16421 16.9994 7.75 16.9994C7.3703 16.9994 7.05651 16.7185 7.00685 16.354L7 16.2526V9.74618C7 9.33374 7.33579 8.9994 7.75 8.9994ZM16.25 6.9994C16.6297 6.9994 16.9435 7.27381 16.9932 7.62983L17 7.72881V16.27C17 16.6728 16.6642 16.9994 16.25 16.9994C15.8703 16.9994 15.5565 16.725 15.5068 16.369L15.5 16.27V7.72881C15.5 7.32597 15.8358 6.9994 16.25 6.9994ZM11.9751 11.9961C12.3458 11.9925 12.6549 12.2628 12.707 12.6168L12.7146 12.7153L12.75 16.2626C12.754 16.6637 12.4293 16.9921 12.0249 16.9962C11.6542 16.9997 11.3451 16.7295 11.293 16.3755L11.2854 16.277L11.25 12.7296C11.246 12.3285 11.5707 12.0001 11.9751 11.9961Z",
    fill: "#5566AA"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataUsage);
export default __webpack_public_path__ + "static/media/dataUsage.9a41df75.svg";
export { ForwardRef as ReactComponent };